import React from "react";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import no_image from "../../assets/images/no_image.png";
import {
  Typography,
  Card,
  CardContent,
  CardMedia,
  CardActionArea,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { addCheffItemToCart } from "../../store/ReduxCheffCartReducer";

export default function CheffItemCard({
  cheffItem,
  IMAGEBASEURL,
  onViewOrder,
}) {
  const theme = useTheme();
  const styles = useStyles(theme);

  const dispatch = useDispatch();

  const handleAddToCart = () => {
    dispatch(addCheffItemToCart(cheffItem));
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "LKR",
    }).format(price);
  };

  return (
    <Card sx={styles.cs_card}>
      <CardActionArea sx={styles.cs_card_actions} onClick={handleAddToCart}>
        <CardMedia
          component="img"
          image={
            cheffItem.WEBIMAGEPATH
              ? `${IMAGEBASEURL}${cheffItem.WEBIMAGEPATH.replace("~", "")}`
              : no_image
          }
          alt={cheffItem.ENUSER || "Product Image"}
          sx={styles.cs_card_media}
        />
        <CardContent sx={styles.cs_card_content}>
          <Typography
            sx={{
              ...theme.typography.caption,
              ...styles.text_center,
              color: theme.palette.text.primary,
              paddingBottom: "5px",
              borderBottom: "1px solid",
              borderColor: theme.palette.stroke.main,
            }}
            gutterBottom
            component="div"
          >
            {cheffItem.MENUREFCODE}
          </Typography>
          <Typography
            noWrap
            p={"2px 20px"}
            sx={{
              ...theme.typography.body2,
              ...styles.text_center,
              color: theme.palette.text.primary,
            }}
          >
            {cheffItem.MENUNAME}
          </Typography>
          <Typography
            sx={{
              ...theme.typography.caption,
              ...styles.text_center,
              color: theme.palette.input_field.text,
            }}
          >
            {formatPrice(cheffItem.ITEMRATE)}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
